module.exports = __webpack_public_path__ + "static/media/s3serverless.6e473a95.png";